import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-chart-title',
  templateUrl: './chart-title.component.html',
  styleUrls: ['./chart-title.component.scss'],
})
export class ChartTitleComponent {
  @Input() title: string;
}
